// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"7774aa2f","187":"dc8203d7","652":"a85dfbd1","917":"c9a24aaa"}[chunkId] + ".chunk.js";
};